import { PayablePaymentStatusEnum, ShrimpTypeEnum } from "@gtpl/shared-models/common-models";
import { InvoiceStatusEnum } from "@gtpl/shared-models/masters";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('rm_invoice')
export class RmInvoice {

    @PrimaryGeneratedColumn("increment", { name: 'rm_invoice_id' })
    rmInvoiceId: number;

    @Column('varchar',{
        nullable: false,
        length:50,
        name: 'invoice_number'
    })
    invoiceNumber: string;

    @Column('datetime',{
        nullable: false,
        name: 'invoice_date'
    })
    invoiceDate: Date;

    @Column('varchar',{
        nullable: false,
        length:50,
        name: 'batch_number'
    })
    batchNumber: string;

    @Column('int',{
        nullable: false,
        name: 'grn_id'
    })
    grnId: number;

    @Column('int',{
        nullable: false,
        name: 'grn_item_id'
    })
    grnItemId: number;

    @Column('int',{
        nullable: false,
        name: 'indent_id'
    })
    indentId: number;

    @Column('int',{
        nullable: true,
        name: 'defect_id'
    })
    defectId: number;

    @Column('int',{
        nullable: false,
        name: 'plant_id'
    })
    plantId: number;

    @Column('decimal',{
        nullable: false,
        name: 'count',
        precision:5,scale:2,
        unsigned:true,
    })
    count: number;

    @Column('decimal',{
        nullable: false,
        name: 'quantity',
        precision:10,scale:3,
        unsigned:true,
    })
    quantity: number;

    @Column('decimal',{
        nullable: false,
        name: 'unit_price',
        precision:10,scale:2,
        unsigned:true,
    })
    unitPrice: number;

    @Column('decimal',{
        nullable: false,
        name: 'total_amount',
        precision:10,scale:2,
        unsigned:true,
    })
    totalAmount: number;

    @Column('enum',{
        nullable: false,
        name: 'type',
        enum:ShrimpTypeEnum
    })
    type: ShrimpTypeEnum;

    @Column('text',{
        nullable: true,
        name: 'invoice_remarks'
    })
    invoiceRemarks: string;

    @Column('varchar',{
        name:'bill_to',
        length: 50,
        nullable:false
    })
    billTo : string

    @Column('varchar',{
        name:'bill_to_type',
        length: 50,
        nullable:false
    })
    billToType : string

    @Column('varchar',{
        name:'financier_name',
        length: 50,
        nullable:false
    })
    financierName : string

    @Column("enum", {
        nullable: false,
        name: "inv_status",
        enum:InvoiceStatusEnum,
        default:InvoiceStatusEnum.OPEN
    })
    invoiceStatus: InvoiceStatusEnum;

    @Column('boolean',{
        name:'mis_flag',
        default:0
    })
    misFlag : boolean

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column('int',{
        name:'ref_no',
    })
    refNo : number

    @Column('varchar',{
        name:'financial_year',
        length : 20
    })
    financialYear : string
 @Column('decimal',{
        name:'payment',
        precision:10,scale:2,
        default:0.00
    })
    payment : number
     @Column({
            type: 'enum',
            enum: PayablePaymentStatusEnum,
            nullable: true,
            default: PayablePaymentStatusEnum.OPEN,
            name: 'payment_status'
        })
        paymentStatus: PayablePaymentStatusEnum;
    
}